/**
 * AdminLayout - Área admin (dark, sidebar + topbar)
 */
import { Outlet } from "react-router-dom";
import AdminSidebar from "@/components/admin/AdminSidebar";
import AdminTopbar from "@/components/admin/AdminTopbar";
import { useEffect } from "react";

export default function AdminLayout() {
    useEffect(() => {
        document.documentElement.classList.add("dark");
        return () => {
            document.documentElement.classList.remove("dark");
        };
    }, []);

    return (
        <div className="min-h-dvh bg-background text-foreground bg-noise" data-testid="admin-layout">
            <div className="flex">
                <AdminSidebar />
                <div className="flex-1 min-w-0 flex flex-col">
                    <AdminTopbar />
                    <main className="flex-1 px-4 sm:px-6 lg:px-8 py-5 sm:py-6 max-w-[1400px] w-full mx-auto">
                        <Outlet />
                    </main>
                </div>
            </div>
        </div>
    );
}
